import React, { FC, ReactNode, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import ActivityFrame from "../../../components/activity-frame/activity-frame";
import Breadcrumb from "../../../components/breadcrumb/breadcrumb";
import Tabs, { getTabsListFromLabels } from "../../../components/tabs/tabs";
import { toast } from "react-toastify";
import ReasonCodeTab from "../../../containers/reason-codes-tab";
import { useLocale } from "../../../contexts/localeContext";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { Category } from "../../../models/Category";
import { getReasonCodes } from "../../../services/reasonCodeService";
import { showError } from "../../../services/utilities/ServiceError";
import {useTabCount} from "../../../hooks/useCategoryTab";
import {Filter} from "../../../models/Filter";
import {getListOfSiteIdsFromFilter} from "../../../utilities/tabUtils";

const ReasonCodes: FC = () => {
    const [selected, setSelected] = useState(0);
    const [busy, setBusy] = useState(false);
    const history = useHistory();
    const [categories, setCategories] = useState<Category[]>([]);
    const [tabContent, setTabContent] = useState<ReactNode[]>([]);
    const { translate } = useLocale();

    const { updateTabCount } = useTabCount({
        tableName: "AccessReasonCodes",
        categories,
        setCategories,
    });

    const buildCategoriesData = async () => {
        try {
            setBusy(true);
            const reasonCodes = await getReasonCodes();
            setCategories([
                {
                    displayName: translate.byKey(TranslationKeys.reasonCodes),
                    heading: translate.byKey(TranslationKeys.reasonCodes),
                    value: "",
                    id: 0,
                    count: 0,
                },
            ]);
            setBusy(false);
        } catch (error) {
            showError(error, toast.warn);
        }
    }

    useEffect(() => {
        buildCategoriesData();
    }, []);

    useEffect(() => {
        if (categories.length > 0) {
            const newTabContent = [<ReasonCodeTab onFilterChange={onFilterChange}/>];
            setTabContent(newTabContent);
        }
    }, [categories]);

    const onFilterChange = (filters:Filter[]) => {
        const siteIds = getListOfSiteIdsFromFilter(filters)
        updateTabCount(siteIds)
    }

    return (
        <>
            <ActivityFrame busy={busy} className="flex flex-grow overflow-y-hidden">
                <div className="pt-4 pl-4 pb-4 flex flex-col flex-grow ">
                    <Breadcrumb
                        path={[
                            { value: '/access-control/hardware', displayName: translate.byKey(TranslationKeys.hardware) },
                            { value: "/access-control/hardware/reason-codes", displayName: translate.byKey(TranslationKeys.reasonCodes) }]}
                        onClick={(item) => history.push(item.value)}>
                    </Breadcrumb>
                    <Tabs
                        className="overflow-y-hidden"
                        tabs={getTabsListFromLabels(categories)}
                        onSelect={(i) => setSelected(i)}
                        selected={selected}
                        onAdd={() => { }}
                        add={false}
                        tabStyle={{}}>
                        {tabContent[selected]}
                    </Tabs>
                </div>
            </ActivityFrame>
        </>
    );
};

export default ReasonCodes;
